import { useMutation, useQueryClient } from 'react-query';
import { apiWithToken } from '../utils/dispatchRecipe';
import { apiKeys } from '../utils/apiKeys';
import reactQueryKeys from '../queryKeys';

export const useUpdateEnvVar = () => {
  const queryClient = useQueryClient();
  const update = useMutation((payload: {
    name: string;
    development: string;
    production: string;
  }) => apiWithToken({
    url: apiKeys['update.environment.variables'],
    method: 'POST',
    payload
  }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([reactQueryKeys.envVarsList]);
      }
    }
  );
  return { updateEnvVar: update.mutateAsync, isLoading: update.isLoading };

};
